/* eslint-disable
    guard-for-in,
    no-restricted-syntax,
    no-unused-expressions,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.controller('rtaCtrl', ($scope, $state, AccountService, AlertManager, DataAccess,
    NgTableParams, AdminComments, ReferencesService, BoFeaturesService, ErrorCatcher) => {
    const crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.canEscalate = BoFeaturesService.isFeatureOn('canEscalate')
    $scope.canMarkLost = BoFeaturesService.isFeatureOn('canMarkLost')

    const refresh = function () {
        $scope.refreshing = true
        return DataAccess.contractsOverdues().$promise.then((data) => {
            data.forEach((contractElec) => {
                contractElec.fullname = `${contractElec.account.givenname} ${contractElec.account.sn}`
                contractElec.affectation = contractElec.affectationForRTA[0]
                const affectedUser = contractElec.affectation != null ? contractElec.affectation.user : undefined
                contractElec.affectationUser = affectedUser ? (`${affectedUser != null ? affectedUser.givenname : undefined} ${affectedUser != null ? affectedUser.sn : undefined}`) : undefined
                contractElec.affectationId = affectedUser != null ? affectedUser.id : undefined
                contractElec.balance = contractElec.contractBalanceStatic.balance
            })
            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 25,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data })
            return $scope.tableParams
        })
        .catch(ErrorCatcher)
        .finally(() => ($scope.refreshing = false))
    }

    $scope.refresh = refresh
    refresh()

    ReferencesService.getRef('contractStatus').then((contractStatusMapping) => {
        const map = []
        for (const k in contractStatusMapping) {
            const v = contractStatusMapping[k]
            if (k && v && v[0]) {
                map.push({ id: k, label: v[0].label_fr })
            }
        }
        return ($scope.contractMapping = map)
    })

    $scope.isActive = (state) => $state.is(state)

    $scope.isLateRequest = (contractElec) => moment(contractElec.distributor_request_date).isBefore(moment().add(-48, 'hours'))

    $scope.isLateInter = (contractElec) => moment(contractElec.intervention_date).isBefore(moment().add(-24, 'hours'))

    $scope.isLateSub = (contractElec) => (contractElec.status === 0) && moment(contractElec.creation_ts).isBefore(moment().add(-24, 'hours'))


    // AFFECTATION
    $scope.affectationFields = {
        affectationId: {
            label: 'Utilisateur',
            required: true,
            type: 'select',
            enum: [],
        },
    }

    $scope.escalationFields = {
        escalationId: {
            label: 'Utilisateur',
            required: true,
            type: 'select',
            enum: [],
        },
        comment: {
            label: 'Raison',
            required: true,
            type: 'text',
        },
    }

    let rawUserList = []
    let rawEscList = []

    const refreshUsers = function () {
        DataAccess.users({ org: BoFeaturesService.get('provider') }).$promise.then((data) => {
            rawUserList = data
            const userList = []
            _.forEach(data, (d) => {
                let label = `${d.givenname} ${d.sn}`
                if (d.groups) {
                    if (crossOrg) {
                        label += ` (${d.organization} - ${d.groups})`
                    } else {
                        label += ` (${d.groups})`
                    }
                }
                return userList.push({ value: d.id, label })
            })
            return ($scope.affectationFields.affectationId.enum = _.orderBy(userList, 'label'))
        })
        if ($scope.canEscalate) {
            return DataAccess.getEscalationList().$promise.then((data) => {
                rawEscList = data
                const escList = []
                _.forEach(data, (d) => {
                    const label = `${d.givenname} ${d.sn}`
                    return escList.push({ value: d.id, label })
                })
                return ($scope.escalationFields.escalationId.enum = _.orderBy(escList, 'label'))
            })
        }
    }

    refreshUsers()

    $scope.affect = function (contractElec) {
        const mail = __guard__(_.find(rawUserList, { id: contractElec.affectationId }), (x) => x.mail)
        return DataAccess.affectContract({ id_contract: contractElec.id, id_account: contractElec.affectationId, affectation_purpose: 'RTA', mail }).$promise.then((result) => {
            AlertManager.success('Contrat affecté')
            return refresh() }).catch(ErrorCatcher)
    }

    $scope.escalate = function (contractElec) {
        const mail = __guard__(_.find(rawEscList, { id: contractElec.escalationId }), (x) => x.mail)
        AdminComments.addComment({ object: contractElec.id, comment: contractElec.comment }).$promise
        .catch(ErrorCatcher)
        return DataAccess.affectContract({ id_contract: contractElec.id, id_account: contractElec.escalationId, affectation_purpose: 'RTA', mail }).$promise.then((result) => {
            AlertManager.success('Contrat remonté à l\'escalade')
            return refresh() }).catch(ErrorCatcher)
    }

    // ACTIONS
    $scope.actionFields = {
        action: {
            label: 'Action',
            required: true,
            type: 'select',
            enum: [
                { label: 'Client contacté - message', value: 'client_contact_msg' },
                { label: 'Client contacté - KO', value: 'client_contact_ko' },
                { label: 'Enedis Contacté - msg', value: 'client_enedis_msg' },
                { label: 'Enedis Contacté - KO', value: 'client_enedis_ko' },
            ],
        },
    }

    // <NOT IN USE> (for now)
    $scope.actionPayload = {
        action: 'client_contact_ok',
    }

    const logForContract = (contractElec, msg) =>
        AdminComments.addComment({ object: contractElec.id, comment: msg }).$promise
        .catch(ErrorCatcher)
  ;

    ({
        actions: {
            client_contact_msg(contractElec) {
                return logForContract(contractElec, 'RTA:<br> Le client a été contacté sans succès, un message a été laissé.')
            },
            // Send EMAIL + SMS
            client_contact_ko(contractElec) {
                return logForContract(contractElec, 'RTA:<br> Le client a été contacté, mais ne désire plus poursuivre sa commande.')
            },
            client_enedis_msg(contractElec) {
                return logForContract(contractElec, 'RTA:<br> Enedis a été contacté sans succès, un message a été laissé.')
            },
            client_enedis_ko(contractElec) {
                return logForContract(contractElec, 'RTA:<br> Enedis a été contacté, une indisponibilité demande de rélancer la demande plus tard.')
            },
        },
    })
    // </NOT IN USE> (for now)

    $scope.commentPayload = {
        comment: '',
    }

    $scope.commentFields = {
        comment: {
            label: 'Commentaire (optionnel)',
            type: 'text',
        },
    }

    $scope.takeAction = function (contractElec) {
        if ($scope.commentPayload.comment) {
            logForContract(contractElec, `Relance à l'amiable : ${$scope.commentPayload.comment}`)
        }
        if (contractElec.affectation) {
            return DataAccess.takeActionOnAffectation({ id: contractElec.affectation.id }, { action: $scope.actionPayload.action }).$promise.then(() => {
                AlertManager.success('Action logguée')
                return refresh() }).catch(ErrorCatcher)
        }
        return AlertManager.error('Pas encore affecté')
    }


    $scope.columns = {
        'id': { label: 'Id', mode: 'search_wildcard', length: 9 },
        'fullname': { label: 'Nom', mode: 'search_wildcard' },
        'status': { label: 'Statut', mode: 'search_operator' },
        'affectation.nb_actions': { label: 'Etape', mode: 'filter' },
        'last_action_date': { label: 'Date dernière étape', mode: 'search_operator' },
        'balance': { label: 'Doute', mode: 'search_operator' },
        'affectationUser': { label: 'Affectation', mode: 'search_wildcard' },
    }
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
